
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 0a3 3 0 013 3v8.999a3 3 0 01-3 3H10.901a.2.2 0 00-.2.208l.234 6.16a.2.2 0 01-.335.155l-7.13-6.471a.2.2 0 00-.134-.052H3a3 3 0 01-3-3V3a3 3 0 013-3h18zM4.604 8.667c-.305 0-.553.268-.553.6 0 .33.248.6.553.6h7.385c.306-.001.553-.27.553-.6 0-.332-.247-.6-.553-.6H4.604zm10.154 0c-.306 0-.553.268-.553.6 0 .33.247.599.553.6h4.615c.306 0 .554-.27.554-.6 0-.332-.248-.6-.554-.6h-4.615zm-10.154-4c-.305 0-.553.268-.553.6 0 .33.248.6.553.6h14.769c.306 0 .554-.27.554-.6 0-.332-.248-.6-.554-.6H4.604z","fill":"currentColor"}})])
          )
        }
      }
    